module.exports = new __parcel__URL__("gosat-based-ch4budget-yeargrid-v1.thumbnails.priori.wetlands.7dc9ba6f.png").toString();